import { FunctionComponent } from 'react'
import { IForumSearchResultItem } from 'Frontend/scripts/models/forums.model'
import ThreadItem from './ThreadItem'
import { useTranslation } from 'react-i18next'

interface UnassignedThreadProps {
  items: IForumSearchResultItem[]
}

const ThreadList: FunctionComponent<UnassignedThreadProps> = ({ items }) => {
  const { t } = useTranslation()
  return (
    <ul className="list-unstyled d-flex flex-column">
      {items && items?.length > 0 ? (
        <>{items?.map((thread) => <ThreadItem key={`thread-${thread.id}`} thread={thread} />)}</>
      ) : (
        <span>{t('there-are-no-questions')}</span>
      )}
    </ul>
  )
}

export default ThreadList
